// export const LockerStatus = [
//     { name: 'open', value: 'open' },
//     { name: 'close', value: 'close' }
// ]
export const LockerStatus = [ 'open','close']
